/**
 * Support page.
 * Minimal tip jar / donation page.
 */

import { useNavigate } from 'react-router-dom';
import './Support.css';

export function Support() {
    const navigate = useNavigate();

    return (
        <div className="page support-page">
            <div className="page-content">
                <header className="support-header">
                    <h1>Support</h1>
                </header>

                <section className="support-content">
                    <p className="support-text">
                        Daily Puzzle is free to play. If you enjoy it, consider supporting
                        the project to help keep it running.
                    </p>

                    <a
                        href="https://ko-fi.com/dailypuzzle"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="support-button"
                    >
                        ☕ Buy me a coffee
                    </a>
                </section>

                <button className="back-button" onClick={() => navigate('/daily')}>
                    Back to Daily
                </button>
            </div>
        </div>
    );
}
